import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IPageNumberInfoProps = {
  currentStep: number
  totalSteps: number
  title?: string
  separator?: boolean
}

export const PageNumberInfo = observer(
  ({ currentStep, totalSteps, title, separator = true }: IPageNumberInfoProps) => {
    return (
      <div>
        <Typography
          ariaLabel='upgrade_billing'
          variant='body-xs-regular'
          color='var(--gray-80)'
          className={styles.upgradeLabel}
        >
          {title}
          {separator && <Typography ariaLabel='separator' className={styles.separator} />}
          {currentStep} of {totalSteps}
        </Typography>
      </div>
    )
  }
)
